module.exports = false;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amcharts/amcharts4/node_modules/core-js/internals/is-pure.js
// module id = 2917
// module chunks = 1